import { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { StockExportGroupBy } from "types";

type StockExportGroupingModalProps = {
  open: boolean;
  loading?: boolean;
  allowUngrouped?: boolean;
  onClose: () => void;
  onConfirm: (groupBy: StockExportGroupBy) => void;
};

export default function StockExportGroupingModal({
  open,
  loading = false,
  allowUngrouped = false,
  onClose,
  onConfirm,
}: StockExportGroupingModalProps) {
  const [groupBy, setGroupBy] = useState<StockExportGroupBy | "">("");

  useEffect(() => {
    if (!open) {
      setGroupBy("");
    }
  }, [open]);

  const handleClose = () => {
    if (loading) return;
    onClose();
  };

  const handleConfirm = () => {
    if (!groupBy) return;
    onConfirm(groupBy);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Exportar stock</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" mb={2}>
          Seleccione cómo desea exportar el stock.
        </Typography>
        {loading && (
          <Typography variant="body2" color="text.secondary" mb={2}>
            Preparando export, esto puede demorar unos segundos...
          </Typography>
        )}

        <FormControl disabled={loading}>
          <RadioGroup
            value={groupBy}
            onChange={(event) =>
              setGroupBy(event.target.value as StockExportGroupBy)
            }
          >
            <FormControlLabel
              value="location"
              control={<Radio />}
              label="Agrupar subtotales por ubicación"
            />
            <FormControlLabel
              value="article"
              control={<Radio />}
              label="Agrupar subtotales por artículo"
            />
            {allowUngrouped && (
              <FormControlLabel
                value="none"
                control={<Radio />}
                label="Sin agrupar"
              />
            )}
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          disabled={!groupBy || loading}
          startIcon={
            loading ? <CircularProgress color="inherit" size={16} /> : undefined
          }
        >
          {loading ? "Exportando..." : "Exportar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
